import { Component } from "@angular/core";
import { Extrainfo } from "src/app/models/form/book-data";
import { FormDataService } from "src/app/services/form-data.service";

@Component({
  selector: "app-migrationsverket-other-details",
  templateUrl: "./migrationsverket-other-details.component.html",
  styleUrls: ["./migrationsverket-other-details.component.scss"],
})
export class MigrationsverketOtherDetailsComponent {
  extrainfo: Extrainfo;

  constructor(
    private formDataService: FormDataService,
    public formData: FormDataService,
  ) {
    this.extrainfo = formDataService.extrainfo;
  }
}
